import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  campaignList: [],
  campaignPageNumber: 1,
  campaignLoading: true,
};

const campaignSlice = createSlice({
  name: "campaigns",
  initialState: initialState,
  reducers: {
    campaignReducer(state, action) {
      state.campaignList = action.payload;
      // state.feedCount = action.payload[0].countPost;
      state.campaignLoading = false;
    },
    campaignReducerReset() {
      return initialState;
    },
  },
});

export const { campaignReducer, campaignReducerReset } = campaignSlice.actions;
export default campaignSlice.reducer;
